import { defineMessages } from 'react-intl';

export const billingRunsMessages = defineMessages({
    systemLogs: { id: 'system-logs', defaultMessage: 'System logs' },
    billingRuns: { id: 'billing-runs', defaultMessage: 'Billing runs' },
    billingRun: { id: 'billing-run', defaultMessage: 'Billing run' },
    billingRunDashboard: { id: 'billing-run-dashboard', defaultMessage: 'Billing run dashboard' },
    backToAllBillingRuns: { id: 'back-to-all-billing-runs', defaultMessage: 'Back to all billing runs' },
    charging: { id: 'billing-run-charging', defaultMessage: 'Charging' },
    invoicing: { id: 'billing-run-invoicing', defaultMessage: 'Invoicing' },
    running: { id: 'billing-run-running', defaultMessage: 'Running' },
    completed: { id: 'billing-run-completed', defaultMessage: 'Completed' },
    failed: { id: 'billing-run-failed', defaultMessage: 'Failed' },
    businessDate: { id: 'business-date', defaultMessage: 'Business date' },
    startedAt: { id: 'started-at', defaultMessage: 'Started at' },
    finishedAt: { id: 'finished-at', defaultMessage: 'Finished at' },
    triggeredBy: { id: 'triggered-by', defaultMessage: 'Triggered by' },
    scheduledRun: { id: 'scheduled-run', defaultMessage: 'Scheduled' },
    totalCount: { id: 'total-count', defaultMessage: 'Total' },
    succeededCount: { id: 'succeeded-count', defaultMessage: 'Succeeded' },
    failedCount: { id: 'failed-count', defaultMessage: 'Failed' },
    skippedCount: { id: 'skipped-count', defaultMessage: 'Skipped' },
    errorDetail: { id: 'error-detail', defaultMessage: 'Error detail' },
    triggerBillingRun: { id: 'trigger-billing-run', defaultMessage: 'Run billing now' },
    triggerBillingRunSubtitle: {
        id: 'trigger-billing-run-subtitle',
        defaultMessage: 'Start a manual run. Manual runs are not limited to once a day.',
    },
    businessDateHint: {
        id: 'business-date-hint',
        defaultMessage: 'Leave empty to process today.',
    },
    triggerBillingRunSuccess: { id: 'trigger-billing-run-success', defaultMessage: 'Billing run started' },
    triggerBillingRunSuccessDescription: {
        id: 'trigger-billing-run-success-description',
        defaultMessage: 'The run is processing. Refresh to follow its progress.',
    },
});
